import { createServerFn } from "@tanstack/react-start";
import { requireSupabaseAuth } from "@/integrations/supabase/auth-middleware";

export const getDisclaimerStatus = createServerFn({ method: "GET" })
  .middleware([requireSupabaseAuth])
  .handler(async ({ context }) => {
    const { supabase, userId } = context;
    const { data } = await supabase
      .from("profiles")
      .select("disclaimer_accepted_at")
      .eq("user_id", userId)
      .maybeSingle();
    return { acceptedAt: data?.disclaimer_accepted_at ?? null };
  });

export const acceptDisclaimer = createServerFn({ method: "POST" })
  .middleware([requireSupabaseAuth])
  .handler(async ({ context }) => {
    const { supabase, userId } = context;
    const now = new Date().toISOString();

    // profiles has no unique constraint on user_id, so we can't use upsert.
    // Update existing rows; if none exist, insert a new one.
    const { data: updated, error: updateError } = await supabase
      .from("profiles")
      .update({ disclaimer_accepted_at: now })
      .eq("user_id", userId)
      .select("id");
    if (updateError) throw new Error(updateError.message);

    if (!updated || updated.length === 0) {
      const { error: insertError } = await supabase
        .from("profiles")
        .insert({ user_id: userId, disclaimer_accepted_at: now });
      if (insertError) {
        // 23503 = FK violation: JWT is valid but the auth.users row was deleted.
        // Return silently so the UI doesn't blank; the auth gate will redirect
        // to /auth on the next getUser() refresh.
        if ((insertError as { code?: string }).code === "23503") {
          return { acceptedAt: null };
        }
        throw new Error(insertError.message);
      }
    }

    return { acceptedAt: now };
  });
